import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ProfileSettingsTile.css';

const ScorePill = props => {
  const { points, perItem } = props;
  return (
    <span className={css.scorePill}>
      <FormattedMessage
        id={perItem ? 'ProfileSettingsPage.scorePillPerItem' : 'ProfileSettingsPage.scorePill'}
        values={{ points }}
      />
    </span>
  );
};

ScorePill.defaultProps = {
  perItem: false,
};

ScorePill.propTypes = {
  points: PropTypes.number.isRequired,
  perItem: PropTypes.bool,
};

export default ScorePill;
